export default __webpack_public_path__ + "static/media/fotos_seguimiento.dc5d0bd2.png";